// import _ from 'lodash'
import axios from 'axios';

import Vue from 'vue';
import get from 'lodash.get';

import router from '@/router';
import store from '@/store';
// import { Message } from 'element-ui'
// import Auth from '@/store/api/auth'
// import Setup from './store/api/setup'
// import Store from './store'

// const whiteList = ['/', '/login', '/forgotpassword', '/resetpassword']

router.beforeEach((to, from, next) => {
    let timeout = setTimeout(() => {
        store.commit('isReady', false);

        router.app.$Progress.set(0);
        router.app.$Progress.start();
    }, 50);

    if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        // parse meta tags
        router.app.$Progress.parseMeta(meta);
    }

    store.commit('setError', null);
    setTimeout(() => store.commit('updateSidebarVisibility', false), 150);

    document.title = to.meta.title ? to.meta.title : document.title;

    const cms = store.getters.CMS.id;
    const category = get(to.meta, 'category.key');
    const key = get(to.params, 'key');

    const skipMiddleware = get(to.meta, 'skipMiddleware', false);
    if (skipMiddleware) {
        clearTimeout(timeout);
        store.commit('isReady', true);
        router.app.$Progress.finish();
        return next();
    }

    if (category && key && cms) {
        store
            .dispatch('currentPage/fetchCategoryPost', { category, key, cms: parseInt(cms) })
            .then((data) => {
                clearTimeout(timeout);
                // setTimeout(() => store.commit('currentPage/addPageToState', data), 0) // wait for the page transition

                store.commit('currentPage/addPageToState', data);
                store.commit('isReady', true);
                router.app.$Progress.finish();
                next();
            })
            .catch(() => {
                store.commit('isReady', true);
                router.app.$Progress.fail();
                next();
            });
    } else if (cms) {
        store
            .dispatch('currentPage/fetchMenuItem', { path: to.path, cms: parseInt(cms) })
            .then((data) => {
                clearTimeout(timeout);
                // setTimeout(() => store.commit('currentPage/addPageToState', data), 0) // wait for the page transition

                store.commit('currentPage/addPageToState', data.page);
                store.commit('isReady', true);
                router.app.$Progress.finish();
                next();
            })
            .catch(() => {
                store.commit('isReady', true);
                router.app.$Progress.fail();
                next();
            });
    } else {
        next();
    }
});

router.afterEach(async route => {
    const analyticsRoute = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_ANALYTICS_ROUTE}`;

    // async function reportPageView() {
    const reportPageView = route => {
        let pageID;
        if (get(route.meta, 'pageID')) pageID = parseInt(Number(get(route.meta, 'pageID')));

        let menuItemID;
        if (get(route.meta, 'menuItemID')) menuItemID = parseInt(Number(get(route.meta, 'menuItemID')));

        let categoryKey;
        let categoryPageKey;
        if (get(route.meta, 'category.key')) {
            categoryKey = route.meta.category.key;
            categoryPageKey = get(route.params, 'key');
        }

        const referrer = window.referrer || document.referrer;
        window.referrer = window.location.href;

        const data = {
            pageID,
            menuItemID,
            categoryKey,
            categoryPageKey,
            title: get(route.meta, 'title'),
            route: route.fullPath,
            screen: {
                width: screen.width,
                height: screen.height,
                depth: screen.colorDepth
            },
            window: {
                width: window.innerWidth,
                height: window.innerHeight
            }
        };

        return axios.post(analyticsRoute, data, {
            headers: {
                'X-Referer': referrer,
                Authorization: localStorage.getItem('member-token')
                    ? `Bearer ${localStorage.getItem('member-token')}`
                    : null
            }
        });
    };

    if (route.name) {
        if (route.redirectedFrom) {
            // report pageview for route.redirectedFrom
            const routes = router.getRoutes();
            let match = routes.find(el => route.redirectedFrom.split('?')[0].match(el.regex));
            match.fullPath = route.redirectedFrom;
            if (match) await reportPageView(match);
        }

        reportPageView(route);
    }

    // router.app.$Progress.finish();
});
